import { render, staticRenderFns } from "./ClassifiesManage.vue?vue&type=template&id=54212b88&scoped=true"
import script from "./ClassifiesManage.vue?vue&type=script&lang=js"
export * from "./ClassifiesManage.vue?vue&type=script&lang=js"
import style0 from "./ClassifiesManage.vue?vue&type=style&index=0&id=54212b88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54212b88",
  null
  
)

export default component.exports